import Register from '@/models/Register';
import StoreDetails from '@/models/StoreDetails';
import CompanyDetails from '@/models/CompanyDetails';
import User from '@/models/User';
import router from '../../routes';
const getDefaultState = () => ({
  loading: false,
  errorMessage: '',
  appProviders: [],
  appProvider: null,
  providerStoreId: null,
  subscriptionPlans: [],
  step: 1,
  countries: [],
  mobile: '', //6982591305
  tos: false,
  userRegistrationIdentifier: '',
  mobileVerificationCode: '',
  code: '',
  fullname: '',
  password: '',
  confirmPassword: '',
  storeDetails: new StoreDetails(),
  successMessage: '',
  companyDetails: new CompanyDetails(),
  user: new User(),
  privacyPolicyUrl: '',
  termsUrl: '',
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    setLoading(state, payload) {
      state.loading = payload;
    },

    setErrorMessage(state, payload) {
      state.errorMessage = payload;
    },

    setAppProviders(state, payload) {
      state.appProviders = payload;
    },

    setUserInfo(state, payload) {
      state.user = new User(payload);
    },

    setAppProvider(state, payload) {
      state.appProvider = payload.app_provider_id;
      state.providerStoreId = payload.store_id;
    },

    setSubscriptionPlans(state, payload) {
      state.subscriptionPlans = payload;
    },

    setSubscriptionPlan(state, payload) {
      state.storeDetails.store_subscription_plan_id = payload;
      state.companyDetails.company_details.store_subscription_plan_id = payload;
    },

    setStep(state, payload) {
      state.step = payload;
    },

    setCountries(state, payload) {
      state.countries = payload;
    },

    setPrivacyPolicyUrl(state, payload) {
      state.privacyPolicyUrl = payload;
    },

    setTermsUrl(state, payload) {
      state.termsUrl = payload;
    },

    setMobile(state, payload) {
      state.mobile = payload;
    },

    setTos(state, payload) {
      state.tos = payload;
    },

    setUserRegistrationIdentifier(state, payload) {
      state.userRegistrationIdentifier = payload;
    },

    setMobileVerificationCode(state, payload) {
      state.mobileVerificationCode = payload;
    },

    setCode(state, payload) {
      state.code = payload;
    },

    setFullname(state, payload) {
      state.fullname = payload;
    },

    setPassword(state, payload) {
      state.password = payload;
    },

    setConfirmPassword(state, payload) {
      state.confirmPassword = payload;
    },

    setSuccessMessage(state, payload) {
      state.successMessage = payload;
    },
  },

  actions: {
    async getAppProviders({ commit }) {
      try {
        commit('setLoading', true);
        const { data } = await Register.getAppProviders();

        commit('setAppProviders', data.data);
        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        console.error(ex);
      }
    },

    async getSubscriptionPlans({ commit, state }, body) {
      try {
        commit('setLoading', true);
        let plan = '';

        if (body.plan) {
          plan = '?plan=' + body.plan;
        }

        if (body.registerPage == 1) {
          const { data } = await Register.getCompanySubscriptionPlans(state.providerStoreId, plan);
          commit('setSubscriptionPlans', data.data);
        } else {
          const { data } = await Register.getStoreSubscriptionPlans(state.providerStoreId, plan);
          commit('setSubscriptionPlans', data.data);
        }
        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        console.error(ex.response.data.message);
      }
    },

    async getCountries({ commit }) {
      try {
        commit('setLoading', true);
        const { data } = await Register.getCountries();

        commit('setCountries', data.data);
        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        console.error(ex.response.data.message);
      }
    },

    async getPolicyAndTerms({ commit }) {
      try {
        commit('setLoading', true);
        const { data } = await Register.getPolicyAndTerms();

        commit('setPrivacyPolicyUrl', data.data.privacy_policy_shorten_url);
        commit('setTermsUrl', data.data.terms_shorten_url);
        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        console.error(ex.response?.data.message);
      }
    },

    async createAccount({ commit, state }) {
      try {
        commit('setLoading', true);

        const { data } = await Register.createAccount({
          country_id: state.storeDetails.country_id,
          mobile: state.mobile,
          tos: state.tos,
        });

        localStorage.setItem('country', state.storeDetails.country_id);
        localStorage.setItem('mobile', state.mobile);
        localStorage.setItem(
          'userRegistrationIdentifier',
          data.data.user.user_registration_identifier
        );
        localStorage.setItem('mobileVerificationCode', data.data.user.mobile_verification_code);
        localStorage.setItem('registrationStep', 2);

        commit('setMobile', data.data.user.mobile);
        commit('setUserRegistrationIdentifier', data.data.user.user_registration_identifier);
        commit('setMobileVerificationCode', data.data.user.mobile_verification_code);
        commit('setLoading', false);
        commit('setErrorMessage', '');
        commit('setStep', state.step + 1);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response?.data?.message || ex);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },

    async resendCode({ commit, state }) {
      try {
        commit('setLoading', true);

        const { data } = await Register.resendCode({
          user_registration_identifier: state.userRegistrationIdentifier,
        });

        // localStorage.setItem(
        //     "mobileVerificationCode",
        //     data.data.user.mobile_verification_code
        // );
        // commit(
        //     "setMobileVerificationCode",
        //     data.data.user.mobile_verification_code
        // );

        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response.data.message);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },

    async registrateUser({ commit, state }, lang) {
      try {
        commit('setLoading', true);
        let body = state.user;
        body.user_registration_identifier = localStorage.getItem('userRegistrationIdentifier');
        await Register.registrateUser(body);

        const { data: signIn } = await Register.storeSignIn({
          app_provider_id: 1,
          mobile: state.mobile,
          password: body.password,
        });

        localStorage.setItem('accessToken', signIn.access_token);
        commit('setAccessToken', signIn.access_token, {
          root: true,
        });

        // if(signIn.extra_data.user_stores.length > 0){
        //     signIn.extra_data.user.role =
        //     signIn.extra_data.user_stores[0].role.name;
        //     commit(
        //         "setPermissions",
        //         signIn.extra_data.user_stores[0].permissions,
        //         { root: true }
        //     );
        // }
        commit('setUser', signIn.extra_data.user, { root: true });

        localStorage.removeItem('registrationStep');
        localStorage.removeItem('country');
        localStorage.removeItem('mobile');
        localStorage.removeItem('userRegistrationIdentifier');
        localStorage.removeItem('subscriptionPlan');
        localStorage.removeItem('providerStoreId');
        localStorage.removeItem('appProvider');

        commit('setSuccessMessage', 'You have successfully created account');
        const redirectUrl = localStorage.getItem('redirectUrl');

        if (redirectUrl) {
          if (redirectUrl == 'subscription-plans') {
            localStorage.setItem('registerPage', 1);
          } else {
            localStorage.setItem('registerPage', 2);
          }
          // router.push(`/en/app-providers`)
          // const { data } = await Register.getAppProviders();

          localStorage.setItem('appProvider', 1);
          localStorage.setItem('providerStoreId', 1);

          router.push(`/${lang || 'en'}/${redirectUrl}`);
        } else {
          localStorage.setItem('appProvider', 1);
          localStorage.setItem('providerStoreId', 1);
          router.push(`/${lang || 'en'}/user-stores`);
        }
        localStorage.removeItem('redirectUrl');

        commit('setLoading', false);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response?.data?.message || ex);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },

    async verifyMobile({ commit, state }) {
      try {
        commit('setLoading', true);

        await Register.verifyMobile({
          user_registration_identifier: state.userRegistrationIdentifier,
          mobile_verification_code: state.code,
        });

        localStorage.setItem('registrationStep', 3);
        localStorage.removeItem('mobileVerificationCode');

        commit('setLoading', false);
        commit('setErrorMessage', '');
        commit('setStep', state.step + 1);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response.data.message);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },

    async createStore({ commit, state, dispatch }, lang) {
      try {
        commit('setLoading', true);

        state.storeDetails.parent_id = localStorage.getItem('providerStoreId');
        const { data } = await Register.createStore({
          user_details: {
            user_registration_identifier: state.userRegistrationIdentifier,
            full_name: state.fullname,
            password: state.password,
            password_confirmation: state.confirmPassword,
            referral: 'Facebook',
            tos: true,
            marketing: true,
          },
          store_details: state.storeDetails,
        });

        localStorage.setItem('storeId', data.data.store_id);
        dispatch('storePanel/getStore', { root: true });
        commit('setStoreId', data.data.store_id, { root: true });

        localStorage.removeItem('registrationStep');
        localStorage.removeItem('subscriptionPlan');
        localStorage.removeItem('providerStoreId');
        localStorage.removeItem('appProvider');
        localStorage.removeItem('showUserDetails');
        localStorage.removeItem('registerPage');

        commit('setSuccessMessage', 'You have successfully created store');
        commit('setLoading', false);
        commit('setErrorMessage', '');
        commit('storePanel/setPaymentError', true, { root: true });
        router.push(`/${lang || 'en'}/storePanel`);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response.data.message);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },

    async createCompany({ commit, state, dispatch }, lang) {
      try {
        commit('setLoading', true);

        const { data } = await Register.createCompany({
          company_details: state.companyDetails.company_details,
          loyalty_details: state.companyDetails.loyalty_details,
        });

        localStorage.removeItem('registrationStep');
        localStorage.removeItem('subscriptionPlan');
        localStorage.removeItem('providerStoreId');
        localStorage.removeItem('appProvider');
        localStorage.removeItem('showUserDetails');
        localStorage.removeItem('registerPage');

        await commit('setStoreId', data.data.store_id, { root: true });
        localStorage.setItem('storeId', data.data.store_id);

        commit('setSuccessMessage', 'You have successfully created a company');
        commit('setLoading', false);
        commit('setErrorMessage', '');
        commit('loyaltyPanel/setPaymentError', true, { root: true });

        // setTimeout( async () => {
        dispatch('loyaltyPanel/getCompany', { root: true });
        dispatch('loyaltyPanel/getUser', data.data.store_id, { root: true });
        // }, 500);
        router.push(
          `/${lang || 'en'}/loyaltyPanel/general-settings/billing-dashboard/payment-methods`
        );
        setTimeout(async () => {
          router.go();
        }, 300);
      } catch (ex) {
        commit('setLoading', false);
        commit('setErrorMessage', ex.response.data.message);
        setTimeout(() => commit('setErrorMessage', ''), 5000);
      }
    },
  },
};
